import React from "react";
import { useTranslation } from "react-i18next";

import { languageName } from "astrid-helpers/src/languages";

import Form from "../../../../forms/components/Form/Form";

export default function CalendarFiltersLanguagesSelect({ organization }) {
	const { t } = useTranslation();

	const languageFilterOptions = organization.languageOptions.map((lang) => ({
		key: lang,
		value: lang,
		text: languageName(lang),
	}));

	return (
		<Form.Select
			name="languages"
			label={t("prodLanguage", "Production language")}
			options={languageFilterOptions}
			shouldUnregister={false}
			multiple
		/>
	);
}
